// extracted by mini-css-extract-plugin
export default {"cls1":"Lightbox-Content-module--cls1--MKf5c","cls2":"Lightbox-Content-module--cls2--EghnS Lightbox-Content-module--cls1--MKf5c"};